export default __webpack_public_path__ + "static/solution_mob-52b876bbe5c81f4879a02b7fcb49ca6f.png";